import { useController } from "react-hook-form";
import FloatLabel from "./FloatLabel";
import ErrorLabel from "./ErrorLabel";
import { Input } from "@chakra-ui/react";

export default function DateTimePickerControl({
  control,
  placeholder,
  name,
  label,
  isDisabled = false,
  isRequired = false,
  rules,
  ...rest
}) {
  // const { setValue } = useFormContext();

  const {
    field: { value, ...field },
    fieldState: { error },
  } = useController({
    name,
    control,
    rules: { required: isRequired && `${label} is required`, ...rules },
  });

  // useEffect(() => {
  //     !isValidDate(value) && setValue(field.name, isValidDate(value));
  // 	//eslint-disable-next-line
  // }, [value, field]);

  return (
    <FloatLabel label={label} isRequired={isRequired}>
      <Input
        placeholder={placeholder}
        size="md"
        type="datetime-local"
        value={/* isValidDate */ value}
        {...field}
        disabled={isDisabled}
        {...rest}
      />
      <ErrorLabel>{error?.message}</ErrorLabel>
    </FloatLabel>
  );
}
